import { Link } from 'react-router-dom';
import { LogoFull } from '../../components/Logo';
import { ArrowLeft } from 'lucide-react';

/**
 * Layout compartido por las 3 páginas legales públicas.
 * Todo el contenido queda dentro de un article con tipografía Geist consistente.
 */
export default function LegalLayout({ title, updatedAt, children }) {
  return (
    <div className="min-h-screen bg-white text-[#1C2329]">
      <header className="border-b border-[#E5E7EB] bg-white sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <LogoFull height={26} />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-1.5 text-[13px] text-[#374151] hover:text-[#1C2329]"
          >
            <ArrowLeft size={14} /> Volver a Priviax
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-14 lg:py-20">
        <div className="text-[10.5px] uppercase tracking-[0.14em] font-semibold text-[#6B7280] mb-3">
          Documento legal · Priviax
        </div>
        <h1 className="text-[36px] md:text-[44px] font-semibold tracking-[-0.03em] text-[#1C2329] leading-[1.1]">
          {title}
        </h1>
        <div className="mt-3 text-[13px] text-[#6B7280]">
          Última actualización: <span className="text-[#374151] font-medium">{updatedAt}</span>
        </div>

        <article className="mt-10 pv-legal-prose text-[15px] text-[#1C2329] leading-relaxed">
          {children}
        </article>

        <footer className="mt-16 pt-8 border-t border-[#E5E7EB] text-[12.5px] text-[#6B7280]">
          <p>
            <b className="text-[#1C2329]">Auttobots SpA</b> · RUT 77.674.834-K · Cerro el Plomo 5931 Of. 1213, Las Condes, Santiago, Chile ·{' '}
            <a href="mailto:hola@priviax.cl" className="text-[#143A34] underline">hola@priviax.cl</a>
          </p>
          <div className="mt-3 flex flex-wrap gap-4">
            <Link to="/privacidad" className="hover:text-[#1C2329]">Política de Privacidad</Link>
            <Link to="/terminos" className="hover:text-[#1C2329]">Términos y Condiciones</Link>
            <Link to="/cookies-y-almacenamiento" className="hover:text-[#1C2329]">Cookies y Almacenamiento</Link>
          </div>
        </footer>
      </main>
    </div>
  );
}
